import { Button, Spin } from "antd";
import { useState } from "react";
import toast from "react-hot-toast";
import Lottie from "lottie-react";
import mailAnim from "../../assets/animations/mailAnimation.json";
import { DiasableQRCode } from "../../modules/auth/services/otpApi";

const AuthenticatorReset = ({ username, onClose }) => {
  const [loading, setLoading] = useState(false);

  const frontendUrl = process.env.REACT_APP_CLIENT_URL;

  const handleReset = async () => {
    setLoading(true);
    try {
      await DiasableQRCode({ username, frontendUrl });

      toast.success("Un email de réinitialisation a été envoyé");
      onClose?.();
    } catch (error) {
      toast.error("Échec de la réinitialisation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-center mt-3">

      <div style={{ width: 150, margin: "0 auto", marginBottom: 20 }}>
        <Lottie animationData={mailAnim} loop autoplay />
      </div>

      <p className="mb-2">
        Réinitialisation du QR Code
      </p>

      <p className="mb-3 text-muted">
        Un email va être envoyé pour réinitialiser votre authentification.
      </p>

      <div className="d-flex justify-content-center gap-2">
        <Button onClick={onClose} disabled={loading}>
          Retour
        </Button>

        <Button type="primary" onClick={handleReset} disabled={loading}>
          {loading ? <Spin size="small" /> : "Confirmer"}
        </Button>
      </div>
    </div>
  );
};

export default AuthenticatorReset;